import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './SuccessToast.module.css';
import { ReactComponent as CancelSVG } from '@Assets/svg/cancel.svg';
import { ReactComponent as SuccessSVG } from '@Assets/svg/goodOperation.svg';
import { ReactComponent as ErrorSVG } from '@Assets/svg/errorOperation.svg';

interface SuccessToastProps {
	isVisible: boolean;
	message: string;
	duration?: number;
	onClose: () => void;
	type: 'success' | 'error';
}

const SuccessToast: React.FC<SuccessToastProps> = ({ isVisible, message, duration = 8000, onClose, type }) => {
	useEffect(() => {
		if (isVisible) {
			const timer = setTimeout(() => {
				onClose();
			}, duration);

			return () => clearTimeout(timer);
		}
	}, [isVisible, duration, onClose]);

	if (!isVisible) return null;

	return createPortal(
		<div className={styles.toastContainer}>
			<div className={`${styles.toast} ${type === 'success' ? styles.success : styles.error}`}>
				<div className={`${styles.icon} ${type === 'success' ? styles.iconSuccess : styles.iconError}`}>
					{type === 'success' ? <SuccessSVG className={styles.svgOp} /> : <ErrorSVG className={styles.svgOp} />}
				</div>
				<span className={styles.message}>{message}</span>
				<button className={styles.closeButton} onClick={onClose}>
					<CancelSVG className={styles.svg} />
				</button>
			</div>
		</div>,
		document.body
	);
};

export default SuccessToast;
